import { 
  ContainerRequest, 
  UpdateContainerRequest, 
  ContainerQueryParams,
} from '../types/container.type';
import { HttpMethods, makeRequest } from '../helpers/http.helper';

export const getContainers = (params: ContainerQueryParams) => {
  const { organization_id, ...otherParams } = params;
  return makeRequest({
    url: `/container/${organization_id}`,
    method: HttpMethods.GET,
    params: otherParams,
  });
};

export const getContainer = (containerId: string) => {
  return makeRequest({
    url: `/container/${containerId}`,
    method: HttpMethods.GET,
  });
};

export const createContainer = (container: ContainerRequest) => {
  return makeRequest({
    url: '/container',
    method: HttpMethods.POST,
    data: container,
  });
};

export const updateContainer = (containerId: string, container: UpdateContainerRequest) => {
  return makeRequest({
    url: `/container/${containerId}`,
    method: HttpMethods.PUT,
    data: container,
  });
};

export const deleteContainer = (containerId: string) => {
  return makeRequest({
    url: `/container/${containerId}`,
    method: HttpMethods.DELETE,
  });
};

// These endpoints don't exist in the OpenAPI spec
// export const getContainerReadings = (containerId: string, params: { start_date?: string; end_date?: string }) => {
//   return makeRequest({
//     url: `/container/readings/${containerId}`,
//     method: HttpMethods.GET,
//     params,
//   });
// };

// export const generateContainerQRCode = (containerId: string) => {
//   return Promise.resolve(null);
// };

// export const generateBulkContainerQRCodes = (containerIds: string[]) => {
//   return Promise.resolve(null);
// }; 